import { formatMNOK, formatNOK } from "@/lib/format";
import type { SalesDisplayMetric } from "@/lib/sales-display-metrics";

interface DisplaySalesPulseSlideProps {
  metric: SalesDisplayMetric;
  monthLabel: string;
}

function PulseStat({ label, value }: { label: string; value: string }) {
  return (
    <div className="min-w-64 rounded-3xl border border-border/70 bg-card/60 px-10 py-8 text-center shadow-sm">
      <p className="text-xl text-muted-foreground">{label}</p>
      <p className="mt-2 text-5xl font-bold tabular-nums">{value}</p>
    </div>
  );
}

/** TV slide: signed deals in the current calendar month, never pipeline. */
export function DisplaySalesPulseSlide({ metric, monthLabel }: DisplaySalesPulseSlideProps) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-12">
      <div className="text-center">
        <p className="text-2xl font-medium uppercase tracking-[0.24em] text-muted-foreground">Signerte salg · {monthLabel}</p>
        <h2 className="mt-3 text-5xl font-bold">Salgspuls</h2>
      </div>
      <p className="text-9xl font-bold tabular-nums">{formatMNOK(metric.monthSalesKr)}</p>
      <div className="flex gap-8">
        <PulseStat label="Nye salg" value={String(metric.monthDealCount)} />
        <PulseStat label="Snittsalg" value={formatNOK(metric.averageSaleKr)} />
        <PulseStat label="Estimert GEEK" value={formatNOK(metric.monthEstimatedGeekKr)} />
      </div>
    </div>
  );
}
